module.exports = ".recent-update {\n  font-weight: bold; }\n"